import styled from 'styled-components'

export const RemoveAudioSectionWrapper = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`
